// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__17DHW","consentsList":"PatientConsents_consentsList__OuuxC","consentsListEmpty":"PatientConsents_consentsListEmpty__2zBve"};